const versionBreak = 100;
const versionBreakMinusOne = versionBreak - 1;
const branchMap = {
    1: 'release',
    2: 'hotfix',
    3: 'minor-release',
    release: '1',
    hotfix: '2',
    'minor-release': '3',
};
const semverRegex = /^\d+\.\d+\.\d+$/;
function incrementHelper(nextVerIntArray) {
    const nextVersion = nextVerIntArray;
    if (nextVersion[1] === versionBreakMinusOne) {
        ++nextVersion[0];
        nextVersion[1] = 0;
    }
    else {
        ++nextVersion[1];
    }
    nextVersion[2] = 0;
    return nextVersion;
}
function calculateNextReleaseSemver(releaseOrHotfix, currentVersion) {
    const nextVerStringArray = currentVersion.split('.');
    let nextVerIntArray = [];
    nextVerStringArray.forEach((e) => {
        nextVerIntArray.push(Number.parseInt(e, 10));
    });
    if (releaseOrHotfix === branchMap.release) {
        nextVerIntArray = incrementHelper(nextVerIntArray);
    }
    else {
        if (nextVerIntArray[2] === versionBreakMinusOne) {
            nextVerIntArray = incrementHelper(nextVerIntArray);
        }
        else {
            ++nextVerIntArray[2];
        }
    }
    return `${nextVerIntArray[0]}.${nextVerIntArray[1]}.${nextVerIntArray[2]}`;
}
function calculateReleaseVersion(releaseVersion) {
    if (!semverRegex.test(releaseVersion)) {
        return releaseVersion;
    }
    const [major, minor, patch] = releaseVersion.split('.');
    const paddedMinor = minor.length === 1 ? `0${minor}` : minor;
    const paddedPatch = patch.length === 1 ? `0${patch}` : patch;
    if (!+minor && !+patch) {
        return major;
    }
    if (!+patch) {
        return `${major}.${paddedMinor}`;
    }
    return `${major}.${paddedMinor}${paddedPatch}`;
}
function getMainBranchName(execSync) {
    try {
        return execSync(`git branch | grep -Eo '^\\**\\s*(main|master)$' | tr -d '* \\n'`).toString();
    }
    catch (e) {
        console.log('Error accessing main/master branch', e);
        process.exit(1);
    }
}
export default {
    branchMap,
    calculateNextReleaseSemver,
    calculateReleaseVersion,
    getMainBranchName,
};
